import { encoreContextStatus } from "../../contexts/EncoreContext";
import { typeStyleBody1, typeStyleBody2, typeStyleBody3, typeStyleBody4, typeStyleCta1, typeStyleCta2, typeStyleCta3, typeStyleCta4, typeStyleDisplay1, typeStyleDisplay2, typeStyleH1, typeStyleH2, typeStyleH3, typeStyleH4 } from "../../styles";
import { assertNever } from "../../typeHelpers";
export var legacyVariants = {
  display1: 'display1',
  display2: 'display2',
  heading1: 'heading1',
  heading2: 'heading2',
  heading3: 'heading3',
  heading4: 'heading4',
  body1: 'body1',
  body2: 'body2',
  body3: 'body3',
  body4: 'body4',
  cta1: 'cta1',
  cta2: 'cta2',
  cta3: 'cta3',
  cta4: 'cta4'
};
export var variantMap = {
  bass: legacyVariants.display1,
  forte: legacyVariants.display2,
  altoBrio: legacyVariants.heading1,
  alto: legacyVariants.heading2,
  celloCanon: legacyVariants.heading3,
  cello: legacyVariants.heading4,
  ballad: legacyVariants.body1,
  viola: legacyVariants.body2,
  // finale: legacyVariants.body3,
  finale: legacyVariants.body4,
  // metronome: legacyVariants.cta1,
  metronome: legacyVariants.cta2,
  minuetBold: legacyVariants.cta3,
  finaleBold: legacyVariants.cta4
};

function getMappedVariant(variant) {
  return variantMap[variant];
}

export function isLegacyVariant(variant) {
  return variant && legacyVariants.hasOwnProperty(variant);
}
export function legacyVariantCheck(variant, status, deprecatedVariant) {
  // Find proper mapped value and return based on context status
  if (status === encoreContextStatus.deprecated && variantMap.hasOwnProperty(variant)) {
    return deprecatedVariant || getMappedVariant(variant);
  }

  return variant;
}
export var legacyVariantStyles = function legacyVariantStyles(variant) {
  switch (variant) {
    case 'display1':
      return typeStyleDisplay1();

    case 'display2':
      return typeStyleDisplay2();

    case 'heading1':
      return typeStyleH1();

    case 'heading2':
      return typeStyleH2();

    case 'heading3':
      return typeStyleH3();

    case 'heading4':
      return typeStyleH4();

    case 'body1':
      return typeStyleBody1();

    case 'body2':
      return typeStyleBody2();

    case 'body3':
      return typeStyleBody3();

    case 'body4':
      return typeStyleBody4();

    case 'cta1':
      return typeStyleCta1();

    case 'cta2':
      return typeStyleCta2();

    case 'cta3':
      return typeStyleCta3();

    case 'cta4':
      return typeStyleCta4();

    default:
      return assertNever(variant);
  }
};
export function legacyPaddingCheck(paddingBottom, condensed) {
  if (condensed) {
    return '0';
  }

  return paddingBottom;
}